import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-upload-cloud-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16667 13.3333L10.5 10M10.5 10L13.8333 13.3333M10.5 10V17.5M17.1667 13.9524C18.1846 13.1117 18.8333 11.8399 18.8333 10.4167C18.8333 7.88536 16.7813 5.83333 14.25 5.83333C14.0679 5.83333 13.8976 5.73833 13.8051 5.58145C12.7184 3.73736 10.712 2.5 8.41667 2.5C4.96489 2.5 2.16667 5.29822 2.16667 8.75C2.16667 10.4718 2.86287 12.0309 3.98913 13.1613"
        [attr.stroke]="color"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class UploadCloudIcon extends BaseIconComponent {}
